export default __webpack_public_path__ + "static/media/medium-circle.0cd251fc.svg";